import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { SERVER_LOAN_CALCULATOR_BASE_URL } from 'src/environments/environment';
import { CalculatorDataDto } from '@app/model/calculator/calculator-data.dto';

@Injectable({
  providedIn: 'root',
})
export class LoanCalculatorService {
  constructor(
    private http: HttpClient,
  ) { }

  getLoanOffersByQrCodeToken(amount: number, qrCodeToken: string): Observable<CalculatorDataDto> {
    return this.http.post<CalculatorDataDto>(`${SERVER_LOAN_CALCULATOR_BASE_URL}/getLoanOffers/`, { amount, qrCodeToken });
  }
}
